export default __webpack_public_path__ + "static/media/img_top.631a42d6.svg";